// src/QueryForm.js

import React, { useState } from "react";
import axios from "axios";
import { gtag_report_conversion } from "./gTagUtils";

const QueryForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Specific handling for mobile field
    if (name === "mobile") {
      const cleanedValue = value.replace(/\D/g, "");
      if (cleanedValue.length <= 10) {
        setFormData({ ...formData, [name]: cleanedValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.mobile.length !== 10) {
      alert("Phone number must be exactly 10 digits.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/query`,
        formData
      );
      console.log(response.data);
      alert(
        "Query submitted successfully. Our Sales Executive will contact you soon."
      );
      setFormData({ name: "", city: "", mobile: "", message: "" });
      gtag_report_conversion();
      onClose(); // Close the modal on successful submission
    } catch (error) {
      console.error("Error submitting query:", error);
      alert("Failed to submit query");
    }
  };

  return (
    <div className="query-form-modal">
      <h3>PCD Pharma Query</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="city"
          placeholder="Your City"
          value={formData.city}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="mobile"
          placeholder="Your Phone Number"
          value={formData.mobile}
          onChange={handleChange}
          required
          pattern="\d{10}"
          title="Please enter exactly 10 digits."
          maxLength="10"
          minLength="10"
        />
        <textarea
          name="message"
          placeholder="Your Message (Optional)"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        <button type="submit">Submit Enquiry</button>
      </form>
      <button onClick={onClose}>Close</button>
    </div>
  );
};

export default QueryForm;
